module.exports = __webpack_public_path__ + "img/SiqiLi.ac33a8d5.jpg";